import api, { baseURL } from "./axios";
import { getStorefrontHeaders } from "../config/storefrontRuntime";
import { getStorefrontActivityHeaders } from "../utils/storefrontActivityIdentity";

export async function sendStorefrontActivity(payload) {
  const response = await api.post("/public/activity", payload, { timeout: 8000 });
  return response.data;
}

export function sendStorefrontActivityKeepalive(payload) {
  if (typeof window === "undefined" || typeof fetch !== "function") return Promise.resolve(null);
  return fetch(`${baseURL}/public/activity`, {
    method: "POST",
    credentials: "include",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      ...getStorefrontHeaders(),
      ...getStorefrontActivityHeaders(),
    },
    body: JSON.stringify(payload),
  }).catch(() => null);
}
